<template>
  <div
    class="menu-block"
    :class="{'is-open' : !groupCollapsible, 'mobile-clickable' : groupCollapsible && title }"
  >
    <div
      class="title-region"
      @click="collapse()"
    >
      <h4 class="title">
        {{ title }}
      </h4>

      <template v-if="groupCollapsible">
        <div
          class="menu-block-navigation-icon-container"
          :class="contentStateDisplay.classes"
          :title="contentStateDisplay.names"
          :alt="contentStateDisplay.names"
        >
          <icon-base icon-name="chevron-down">
            <icon-chevron-down />
          </icon-base>
        </div>
      </template>
    </div>
    <div
      class="navigation-region"
      :class="{ 'mobile-collapsed': collapsed && title }"
    >
      <ul class="nav-list">
        <li
          v-for="(item, index) in list"
          :key="`nav-list-${item.id}-${index}`"
          class="nav-item"
        >
          <HighlightButton
            :router-link="true"
            :url="item.linkUrl"
            :title="item.linkText"
            button-type="default"
            :url-new-window="item.linkTarget === '_blank'"
            @highlight-button-click="$emit('close-dropdown')"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import IconBase from './icons/iconBase.vue'
import IconChevronDown from './icons/icons/iconChevronDown.vue'
import HighlightButton from './components/button/highlight-button.vue'

export default {
  name: 'menu-block',
  components: {
    IconBase,
    IconChevronDown,
    HighlightButton

  },
  props: {
    title: {
      type: String,
      required: true
    },
    list: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      collapsed: true,
      groupCollapsible: true
    }
  },
  computed: {
    collapsible() {
      return this.groupCollapsible
    },
    contentStateDisplay() {
      let classes = ''
      let names = ''
      let stateDisplay = ''
      const state = this.contentState
      const name = this.stateName

      classes = classes + state
      names = name
      stateDisplay = {
        names,
        classes
      }
      return stateDisplay
    },
    selectorToggleIcon() {
      if (this.collapsed) {
        return 'chevron-up'
      }
      return 'chevron-down'
    },
    contentState() {
      return this.collapsed ? 'set-closed' : 'set-open'
    },
    stateName() {
      return this.collapsed ? 'Closed' : 'Open'
    }
  },
  methods: {
    collapse: function() {
      if (this.groupCollapsible) {
        this.collapsed = !this.collapsed
      }
      else return this.collapsed
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@scss/custom.scss';
    .menu-block {
        --menu-block-icon-color:#333;
        --menu-block-title-font-size:1.2em;
        --menu-block-title-font-weight:400;
        --menu-block-icon-size:1.2em;
    }
    .menu-block {
    grid-row: span 1;
    display: flex;
    flex-direction: column;

    //title
    .title-region {
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap:1em;
        @include media-breakpoint-up(lg) {
            pointer-events:none
        }
        .title{
            margin:0;
            font-size: var(--menu-block-title-font-size);
            font-weight: var(--menu-block-title-font-weight);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: pre-wrap;
            word-break: break-word;
        }
    }
}
.navigation-region {
    margin-top:.5em;
}
.menu-block-navigation-icon-container {
    @include media-breakpoint-up(lg) {
        display: none;
    }
    .icon {
        width:var(--menu-block-icon-size);
        height: var(--menu-block-icon-size);
        transform: rotate(0deg);
        transition: transform 0.2s ease-in-out;
        transform-origin: center;
        fill: var(--menu-block-icon-color);
        stroke:  var(--menu-block-icon-color);
    }
}
.set-open {
    .icon {
        transform: rotate(180deg);
    }
}

//item list
.nav-list {
    list-style: none;
    padding: 0;
    margin: 0;
}
.nav-item {
    list-style: none;
    padding: 0;
    &:not(:first-child) {
        margin-top: 0.5em;
    }
}

@include media-breakpoint-down(md) {
    .navigation-region {
        &.mobile-collapsed {
            display: none;
        }
    }
}
</style>
